import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useGetMeQuery } from './services/authApi';
import { useGetReceiptTemplateQuery } from './services/receiptTemplateApi';
import { setCredentials, logout } from './store/authSlice';
import AuthLoadingScreen from './components/common/AuthLoadingScreen';

export const AuthInitializer = ({ children }) => {
  const dispatch = useDispatch();
  const { token, user } = useSelector((state) => state.auth);

  const { data: meResponse, error, isLoading } = useGetMeQuery(undefined, {
    skip: !token || !!user,
  });

  // Prefetch once per session, as early as possible -- by the time checkout/
  // print happens later, this is already resolved and cached (RTK Query dedupes
  // the identical query wherever mapOrderToReceipt's callers ask for it again).
  useGetReceiptTemplateQuery(undefined, { skip: !token });

  useEffect(() => {
    if (meResponse?.data?.user) {
      const { user, store, organization } = meResponse.data;
      dispatch(setCredentials({ user, store, organization }));
    }
    if (error) dispatch(logout());
  }, [meResponse, error, dispatch]);

  if (token && !user && isLoading) {
    return (
      <AuthLoadingScreen
        title="Restoring your session..."
        subtitle="Syncing profile and terminal details"
      />
    );
  }

  return children;
};
